/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const MOVE_PAYER_TO_PICKER = gql`
  mutation QMovePaymentToPicking($tokenKey: String!, $counter: ID!) {
    qMovePaymentToPicking(tokenKey: $tokenKey, counter: $counter) {
      token {
        id
        tokenKey
      }
      vqmsData {
        isCalledByUser
        isCalledOutByDistCounter
        isCalledOutByPayCounter
        lockedByDistCounter
        lockedByPayCounter
        lockedByUser
        payCounterNo
        subQueue
      }
    }
  }
`;
